export type PREVIEW_BILL_RESPONSE = {
  bill_id: string
  bill_number: string
  content: string
  err_msg: string
}

export type SYNC_REQUEST_PAYLOAD = {
  doc_id: string
}

export interface IDeleteFilePayload {
  document_id: string
}

export enum QUOTATION_PREVIEW_PRINT {
  PRINT = 1,
  PREVIEW = 0
}
